import { styled } from "@styles";

export const Container = styled("div", {
  cursor: "progress",
  height: "100%",

  "@sm": {
    position: "fixed",
    height: "100dvh",
    width: "100dvw",
    top: "0",
    left: "0",
    zIndex: "9999",
  },

  h3: {
    position: "absolute",
    top: "62%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    fontSize: "20px",
    color: "${color.orange} !important",
    textAlign: "center",
    zIndex: "1",
  },

  "> div": {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: "1",
  },

  variants: {
    loading: {
      true: {
        display: "block",
      },
      false: {
        display: "none",
      },
    },
  },

  defaultVariants: {
    loading: false,
  },
});

export const ProgressWrapper = styled("div", {
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
});

export const Background = styled("div", {
  width: "100%",
  height: "100%",
  position: "fixed",
  top: "0",
  right: "0",
  background: "$neutral00",
  opacity: "0.9",
  zIndex: "99",
  margin: "-1px",
});
